import {FormViewEnum} from '../../stores/Form/Form';
import {priority} from '@priority-software/priority-proto-api/lib';

export enum DesignPanels {
    FIELDS,
    ACTIONS,
    SUBFORMS,
    PANELS
}

export enum MoveDirection {
    TOP,
    UP,
    DOWN,
    BOTTOM
}

export const getDesignTypeByActivePanel = (
    activePanel: DesignPanels,
    view: FormViewEnum
): priority.netitems.form.DesignType => {
    if (activePanel === DesignPanels.FIELDS) {
        if (view === FormViewEnum.table) {
            return priority.netitems.form.DesignType.TableViewDesign;
        } else {
            return priority.netitems.form.DesignType.RowViewDesign;
        }
    }
    if (activePanel === DesignPanels.ACTIONS) {
        return priority.netitems.form.DesignType.ActionsDesign;
    }
    if (activePanel === DesignPanels.SUBFORMS || activePanel === DesignPanels.PANELS) {
        return priority.netitems.form.DesignType.SubformsDesign;
    }
    return null;
};
